import clsx from 'clsx';

interface MenuItemProps {
  onClick: () => void;
  disabled?: boolean;
  children: React.ReactNode;
  className?: string;
  icon?: React.ReactNode;
}

function MenuItem({ onClick, disabled, children, className, icon }: MenuItemProps) {
  return (
    <button
      onClick={onClick}
      disabled={disabled}
      className={clsx('group menu-item rounded-sm', className)}
    >
      {icon && <span className="menu-item-icon">{icon}</span>}
      {children}
    </button>
  );
}

export default MenuItem;
